import { render, staticRenderFns } from "./BuyFromJCIReport.vue?vue&type=template&id=15ab7ffa"
import script from "./BuyFromJCIReport.vue?vue&type=script&lang=js"
export * from "./BuyFromJCIReport.vue?vue&type=script&lang=js"
import style0 from "./BuyFromJCIReport.vue?vue&type=style&index=0&id=15ab7ffa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports